import { EditProject, Login, Planner, Register, RoomBuilder } from '@components'
import { DuplicateProject } from '@components/DuplicateProject/DuplicateProject'
import FileUploader from '@components/FileConverter/fileUploader'
import { DuplicateConfirm } from '@components/GenericModals/CopyProjectModal'
import DoorModal from '@components/GenericModals/DoorModal'
import ErrorModal from '@components/GenericModals/ErrorModal'
import { FavoriteModal } from '@components/GenericModals/FavoriteModal'
import LogoutModal from '@components/GenericModals/LogoutModal'
import { OpenProjectModal } from '@components/GenericModals/OpenProjectModal'
import USureModal from '@components/GenericModals/USureModal'
import WindowModal from '@components/GenericModals/WindowModal'
import { IA } from '@components/IA'
import { IAForm } from '@components/IA/IaForm'
import { IaGen } from '@components/IA/iaGen'
import { Information } from '@components/Information'
import { Spinner } from '@components/Loaders/spinner'
import { SpinnerIA } from '@components/Loaders/spinnerIA'
import { ModalConfirm } from '@components/ModalConfirm'
import { SaveConfirm } from '@components/ModalConfirm/SaveConfirm'
import { SaveWrong } from '@components/ModalConfirm/SaveWrong'
import { NewDesign } from '@components/ModalConfirm/newDesign'
import ItemEditor from '@components/ModalEditor/UniversalEditor/ItemEditor'
import { PredefinedRooms } from '@components/PredefinedRooms'
import SaveProject from '@components/Topbar/SaveProject'
import { UserContextProvider } from '@context/user'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom'
import TemporaryOpenProject from './TemporaryOpenProject'
import './index.css'
// Importar analytics - esto inicializará Google Analytics automáticamente NO QUITAR
import '../utils/analytics'

// export { Outlet }

const router = createBrowserRouter([
  {
    path: '/iaform',
    element: <IAForm />,
    children: [
      {
        path: 'spinner',
        element: <SpinnerIA msg={'Generando tu proyecto estilo'} />,
      },
      {
        path: 'imgIAGen',
        element: <IaGen />,
      },
    ],
  },
  { path: '/ia', element: <IA /> },

  // Ruta raíz redirige a /planner
  {
    path: '/',
    element: (
      <Navigate
        to='/planner'
        replace
      />
    ),
  },

  {
    path: '/planner',
    element: <Planner />,
    loader: () => {
      //TODO: mover lógica de cosas al loader!!
      // AÑadir: las texturas, toda la info del usuario blablabla
      // las preferencias, las imágenes iniciales
      return null
    },
    children: [
      { path: '/planner/duplicated', element: <DuplicateConfirm /> },
      { path: '/planner/confirm', element: <ModalConfirm text='Hola' /> },
      { path: '/planner/create/:action', element: <RoomBuilder /> },
      { path: '/planner/login', element: <Login href='/planner' /> },
      { path: '/planner/register', element: <Register /> },
      { path: '/planner/oksave', element: <SaveConfirm /> },
      { path: '/planner/nosave', element: <SaveWrong /> },
      { path: '/planner/newDesign', element: <NewDesign /> },
      { path: '/planner/proyectos', element: <EditProject /> },
      // { path: '/planner/list', element: <ListOfElements /> },
      { path: '/planner/list/textureEdit', element: <ItemEditor /> },

      {
        path: '/planner/copyProject/:idVersiones',
        element: <DuplicateProject />,
      },
      {
        path: '/planner/door/:id',
        element: <DoorModal msg={'Añadir puerta'} />,
      },
      {
        path: '/planner/window/:id',
        element: <WindowModal msg={'Añadir ventana'} />,
      },
      {
        path: '/planner/openProject/:idVersiones',
        element: <OpenProjectModal />,
      },
      { path: '/planner/confirmlogout', element: <LogoutModal /> },
      { path: '/planner/register/error/:errorText', element: <ErrorModal /> },
      { path: '/planner/login/error/:errorText', element: <ErrorModal /> },
      { path: '/planner/proyectos/error/:errorText', element: <ErrorModal /> },
      {
        path: '/planner/downloading',
        element: (
          <Spinner
            msg={'Estamos descargando su proyecto, en unos instantes estará disponible...'}
          />
        ),
      },
      {
        path: '/planner/seivo',
        element: <Spinner msg={'Estamos guardando su diseño, en unos instantes terminamos...'} />,
      },
      { path: '/planner/generateGLB', element: <Spinner msg={'Enviando a nuestros servidores'} /> },
      { path: '/planner/deleteProyect/:idVersiones', element: <USureModal /> },
      { path: '/planner/url/:id', element: <TemporaryOpenProject /> },
      { path: '/planner/info', element: <Information /> },
      { path: '/planner/saveProject', element: <SaveProject /> },
      { path: '/planner/fileUploader', element: <FileUploader /> },
      { path: '/planner/setfav', element: <FavoriteModal /> },
      // { path: '/planner/hdr', element: <HDR /> },
    ],
  },
])

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <UserContextProvider>
      <RouterProvider router={router} />
    </UserContextProvider>
  </StrictMode>,
)
